import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, RemoveFilterCategory, RemoveStockedItemsFilter } from "@insite/client-framework/Store/Pages/ProductList/Handlers/RemoveProductFilters";

replaceInChain(chain, RemoveFilterCategory, props => {
    props.result.categoryId = undefined;
    (props.result as any).categoryIds = (props.result as any).categoryIds?.filter((x:string) => !(props.parameter as any).categoryIds?.find((y:string) => y === x));
    if ((props.result as any).categoryIds?.length === 0) {
        (props.result as any).categoryIds = undefined;
         
    }

    if ((props.result as any).categoryIds?.length === 1){
        props.result.categoryId = (props.result as any).categoryIds[0];
    }


});

addToChainAfter(chain, RemoveStockedItemsFilter, props => {
    (props.result as any).wishlistIds = (props.result as any).wishlistIds?.filter((x:string) => !(props.parameter as any).wishlistIds?.find((y:string) => y === x));
    if ((props.result as any).wishlistIds?.length === 0) {
        (props.result as any).wishlistIds = undefined;
    }
});